(function(){
  var cfg = window.LWP_PRODUCT || { title: 'This item', hasRemote: true };
  var mainImg = document.getElementById('lwpMainImg');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.lwp-gallery__thumbs img'));
  var activeIdx = 0;

  function showThumb(i){
    if(!thumbs.length) return;
    activeIdx = (i + thumbs.length) % thumbs.length;
    thumbs.forEach(function(x){x.classList.remove('is-active')});
    thumbs[activeIdx].classList.add('is-active');
    if(mainImg) mainImg.src = thumbs[activeIdx].getAttribute('data-full');
  }

  thumbs.forEach(function(t, i){
    if(t.classList.contains('is-active')) activeIdx = i;
    t.addEventListener('click', function(){ showThumb(i); });
  });

  var prevBtn = document.getElementById('lwpGalleryPrev');
  var nextBtn = document.getElementById('lwpGalleryNext');
  if(prevBtn) prevBtn.addEventListener('click', function(){ showThumb(activeIdx - 1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ showThumb(activeIdx + 1); });

  document.querySelectorAll('.lwp-tabs__nav button').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.lwp-tabs__nav button').forEach(function(b){b.classList.remove('is-active')});
      document.querySelectorAll('.lwp-tabs__panel').forEach(function(p){p.classList.remove('is-active')});
      btn.classList.add('is-active');
      var target = document.querySelector('.lwp-tabs__panel[data-panel="'+btn.getAttribute('data-tab')+'"]');
      if(target) target.classList.add('is-active');
    });
  });

  var qtyInput = document.getElementById('lwpQtyInput');
  function renderBox(){
    if(!qtyInput) return;
    var qty = parseInt(qtyInput.value, 10) || 1;
    var grid = document.getElementById('lwpBoxGrid');
    if(!grid) return;
    var toyImg = cfg.image
      ? '<img class="lwp-box-item__img" src="' + cfg.image + '" alt="' + cfg.title + '">'
      : '<span class="lwp-box-item__icon">\uD83E\uDDF8</span>';
    var html = '';
    html += '<div class="lwp-box-item">' + toyImg + '<span class="lwp-box-item__label">' + cfg.title + '</span><span class="lwp-box-item__qty">' + qty + '\u00D7</span></div>';
    if(cfg.hasRemote){
      html += '<div class="lwp-box-item"><span class="lwp-box-item__icon">\uD83D\uDCE1</span><span class="lwp-box-item__label">Remote Control</span><span class="lwp-box-item__qty">' + qty + '\u00D7</span></div>';
    }
    html += '<div class="lwp-box-item"><span class="lwp-box-item__icon">\uD83D\uDD0C</span><span class="lwp-box-item__label">USB Charging Cable</span><span class="lwp-box-item__qty">' + qty + '\u00D7</span></div>';
    html += '<div class="lwp-box-item"><span class="lwp-box-item__icon">\uD83D\uDCD6</span><span class="lwp-box-item__label">Instruction Manual</span></div>';
    grid.innerHTML = html;
  }

  var minusBtn = document.getElementById('lwpQtyMinus');
  var plusBtn = document.getElementById('lwpQtyPlus');
  if(minusBtn) minusBtn.addEventListener('click', function(){
    qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    renderBox();
  });
  if(plusBtn) plusBtn.addEventListener('click', function(){
    qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    renderBox();
  });
  if(qtyInput){
    qtyInput.addEventListener('change', renderBox);
    qtyInput.addEventListener('input', renderBox);
  }
  renderBox();

  var modal = document.getElementById('lwpCmpModal');
  var openBtn = document.getElementById('lwpCmpOpen');
  var closeBtn = document.getElementById('lwpCmpClose');
  if(modal && openBtn){
    openBtn.addEventListener('click', function(){ modal.classList.add('is-open'); });
    if(closeBtn) closeBtn.addEventListener('click', function(){ modal.classList.remove('is-open'); });
    modal.addEventListener('click', function(e){ if(e.target === modal) modal.classList.remove('is-open'); });
  }
})();
